// grade.ts - the shared grade-to-visual language for the progress surfaces (S25).
// The progress engine grades decisions on a 1..10 scale (ENGINE_DESIGN §9), a DIFFERENT model from the
// per-hand move-class %; here we paint those grades with the same locked move-class palette (tokens.css)
// so Progress reads like the rest of the app. Four legible bands (the S25 contrast tune Joe signed off):
// green best / teal solid / orange thin / red poor. Reserving book-brown for muddiness we deliberately drop.

export type GradeTone = 'best' | 'exc' | 'mist' | 'blun';

/** Map a 1..10 average grade to a move-class token name for its bar/number color. */
export function gradeTone(g: number): GradeTone {
  if (g >= 8.5) return 'best'; // green: strong
  if (g >= 7) return 'exc'; // teal: solid
  if (g >= 6) return 'mist'; // orange: thin, needs work
  return 'blun'; // red: a real leak
}

/** The CSS custom-property reference for a grade tone, e.g. `var(--exc)`. */
export function toneVar(g: number): string {
  return `var(--${gradeTone(g)})`;
}

/** One-decimal, tabular-friendly grade string (7.6666 -> "7.7"). */
export function fmt1(g: number): string {
  return g.toFixed(1);
}

/** Bar width as a percentage of the 1..10 scale, clamped to a visible minimum so a low bar still shows. */
export function barPct(g: number): number {
  return Math.max(6, Math.min(100, Math.round(g * 10)));
}
